export const CubicBoxData = [
  {
    id: "1",
    icon: "images/Academies/tracks/infrastructure-new-brand.png",
    title: "Infrastructure Engineering & IT Operations",
    para: "The foundational layer that supports all enterprise systems—on-premises or cloud.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.delivery.accenture.com/TT/'>Infrastructure Engineering (IE)</a></li>
            <li>Infrastructure Managed Services (IMS)</li>
            <li><a href='https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/'>Application Management Services (AMS)</a></li>
        </ul>`,
    ],
  },
  {
    id: "2",
    icon: "images/Academies/tracks/Cloud-Platform-new-brand.png",
    title: "Cloud Platforms",
    para: "Scalable and agile platforms that modernize infrastructure and enable digital transformation.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/CloudAcademy/AWS'>AWS</a></li>
            <li><a href='https://atci.lkm.accenture.com/CloudAcademy/Azure'>Azure </a></li>
            <li><a href='https://atci.lkm.accenture.com/CloudAcademy/GCP'>GCP </a></li>
        </ul>`,
    ],
  },
  {
    id: "3",
    icon: "images/Academies/tracks/Data-AI-new.png",
    title: "Data, AI & Analytics",
    para: "Deriving insights and intelligence from enterprise data using modern AI capabilities.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/DataAcademy/'>Data</a></li>
            <li>AI & ML</li>
            <li><a href='https://atcgn.lkm.accenture.com/ATCGNCatalog/Artificial-Intelligence'>Gen AI & Agentic AI</a></li>
        </ul>`,
    ],
  },
  {
    id: "4",
    icon: "images/Academies/tracks/Enterprise-platforms-new.png",
    title: "Enterprise Platforms & Business Applications",
    para: "Core systems of record and enterprise tools essential for business operations.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.eitacademy.accenture.com/SAPAcademy/Courses'>SAP</a></li>
            <li><a href='https://atci.lkm.eitacademy.accenture.com/Salesforce/Courses'>Salesforce</a></li>
            <li><a href='https://atci.lkm.eitacademy.accenture.com/Oracle/Courses'>Oracle</a></li>
            <li>Mainframe</li>
            <li>Commerce & Digital Business Solutions</li>
        </ul>`,
    ],
  },
  {
    id: "5",
    icon: "images/Academies/tracks/Enterprise-Integration-new.png",
    title: "Enterprise Integration & Process Automation",
    para: "Enabling connectivity, automation, and streamlined workflows across systems.",
    lists: [
      `<ul>
            <li>Enterprise Application Integration (EAI)</li>
            <li>Business Process Management (PEGA)</li>
            <li>Robotic Process Automation (RPA)</li>
            <li><a href='https://atci.lkm.accenture.com/LCNCAcademy/home'>Low-Code & No-Code (LCNC)</a></li>
        </ul>`,
    ],
  },
  {
    id: "6",
    icon: "images/Academies/tracks/software-engineering-new.png",
    title: "Software Engineering & Digital Development",
    para: "Developing scalable, user-centric applications on top of integrated platforms.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/JavaAcademy/home'>Java</a></li>
            <li>.Net</li>
            <li>Front-End Web Development (UI/UX)</li>
            <li>Next-Gen Programming Languages</li>
        </ul>`,
    ],
  },
  {
    id: "7",
    icon: "images/Academies/tracks/devops-new-brand.png",
    title: "DevOps, Reliability & Automation",
    para: "Accelerating software delivery and infrastructure agility through automation and resilience.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.delivery.accenture.com/DevOps/'>DevOps</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/SRE/'>Site Reliability Engineering (SRE)</a></li>
            <li>IT Service Automation</li>
        </ul>`,
    ],
  },
  {
    id: "8",
    icon: "images/Academies/tracks/quality-engineering-new.png",
    title: "Quality Engineering (QE) & Software Testing",
    para: "Ensuring reliability, performance, and test-driven development at every stage.",
    lists: [
      `<ul>
            <li>Test Automation</li>
            <li>Performance & Load Testing</li>
            <li>Functional & Non-Functional Testing</li>
            <li>Continuous Testing & DevTestOps</li>
        </ul>`,
    ],
  },
  {
    id: "9",
    icon: "images/Academies/tracks/cybersecurity-new.png",
    title: "Cybersecurity, Risk & Compliance",
    para: "Protecting systems, data, and operations across the enterprise technology stack.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Practices</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Resilience</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Protection</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Cyber Strategy</a></li>
            <li><a href='https://atci.lkm-securitylearninghub.accenture.com/home'>Physical Security</a></li>
        </ul>`,
    ],
  },
  {
    id: "10",
    icon: "images/Academies/tracks/Agile-new-brand.png",
    title: "Agile, Delivery & Leadership",
    para: "Driving effective execution, scaled agile practices, and strategic delivery governance.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.delivery.accenture.com/Agile/'>Agile & Scaled Agile</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/leadershipprograms/'>Delivery Leadership</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/ProjectManagement/home'>Project & Program Management (PM)</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/SystemIntegration/home'>System Integration (SI)</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/DLF/DFA4.0'>Delivery Learning Framework (DLF)</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/TechCore/'>Tech Core Learning</a></li>
        </ul>`,
    ],
  },
  {
    id: "11",
    icon: "images/Academies/tracks/business-new-brand.png",
    title: "Business, Consulting & Client Engagement",
    para: "Maximizing business value through strategic thinking and client-centric transformation.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.delivery.accenture.com/leadershipprograms/BCC'>Building Client Centricity (BCC)</a></li>
            <li><a href='https://atci.lkm.delivery.accenture.com/leadershipprograms/DSA'>Delivery Sales Academy (DSA)</a></li>
            <li>Business & Digital Transformation Strategy</li>
        </ul>`,
    ],
  },
  {
    id: "12",
    icon: "images/Academies/tracks/Human-centric-new.png",
    title: "Specialized & Human-Centric Skills",
    para: "Developing future-ready, people-driven capabilities that complement technical excellence.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/FacilitatorsCommunity/'>Facilitation School</a></li>
            <li><a href='https://wd103.myworkday.com/accenture/learning/course/4a19a44ecbef103d18b1b6682a0f0000?type=9882927d138b100019b928e75843018d'>Design Thinking & Storytelling</a></li>
        </ul>`,
    ],
  },
  {
    id: "13",
    icon: "images/Academies/tracks/fl-icon-brand.png",
    title: "Foreign Language & Culture Academy",
    para: "Language and Culture trainings are aimed at enhancing communication skills and cultural awareness",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.foreignlanguage.accenture.com/'>Foreign Language & Culture Academy</a></li>
        </ul>`,
    ],
  },
  {
    id: "14",
    icon: "images/Academies/tracks/Sustainability-latest-brand.png",
    title: "Sustainability",
    para: "Sustainability in technology fosters Green software solutions that benefit businesses and reduce emissions for a healthier planet.",
    lists: [
      `<ul>
            <li><a href='https://atci.sustainability.accenture.com/learning?h=ls'>Sustainability</a></li>
        </ul>`,
    ],
  },
  {
    id: "15",
    icon: "images/Academies/tracks/Professional-Icon.png",
    title: "Professional Skills",
    para: "Our Professional Skills model is designed to help you unleash your best personality at work. Identifying focus areas based on thorough research of what our clients expect from us is what helped us build these learning paths exclusively for you.",
    lists: [
      `<ul>
            <li><a href='https://atci.lkm.accenture.com/ProfessionalSkills/'>Professional Skills</a></li>
        </ul>`,
    ],
  },
];
